export function isConsolidatedFeedOrder(order: {
    customFields?: { isConsolidatedFeed?: boolean | null } | null;
} | null | undefined): boolean {
    return order?.customFields?.isConsolidatedFeed === true;
}
